module.exports = __webpack_public_path__ + "33af4321d874c8a893bd22252adb49b5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owls/demo-student.png
// module id = 1766
// module chunks = 0